import * as React from 'react';

function SvgCanada(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.73h8.36V0H0v20.73zM27.177 20.73h8.36V0h-8.36v20.73z"
        fill="#EA0020"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.36 20.73h18.817V0H8.36v20.73z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.769 2.687l-1.234 2.395c-.14.26-.39.233-.642.09l-.892-.482.666 3.68c.14.674-.31.674-.53.383l-1.558-1.817-.253.922a.302.302 0 01-.35.218l-1.97-.433.519 1.958c.112.438.196.619-.113.734l-.702.343 3.392 2.87c.132.109.203.302.152.48l-.296 1.015c1.167-.14 2.215-.268 3.38-.409.102 0 .276.092.276.216l-.156 3.717h.569l-.091-3.708c0-.121.158-.225.258-.225 1.17.14 2.215.269 3.383.409l-.3-1.016a.48.48 0 01.156-.48l3.39-2.869-.701-.343c-.31-.115-.223-.296-.112-.734l.518-1.958-1.97.433a.302.302 0 01-.35-.218l-.252-.922-1.558 1.817c-.222.29-.67.29-.53-.383l.664-3.68-.89.482c-.252.143-.503.17-.641-.09l-1.232-2.395z"
        fill="#EA0020"
      />
    </svg>
  );
}

export default SvgCanada;
